<template>
    <div>
        <b>{{ userName }}</b>

        {{ action }} 

        <template v-if="event.data.component">
            <template v-if="event.action == 'component_models_deleted' || event.action == 'component_models_enabled' || event.action == 'component_models_disabled'">
                <template v-if="Object.keys(event.data.model).length > 0">
                   {{ Object.keys(event.data.model).length }}
                </template>

                
                {{ pluralize(event.data.component.name) }} 
            </template>
            <template v-else>
                {{ singular(event.data.component.name) }} 
            </template>
            
        </template>
    </div>
</template>

<script>
import Pluralize from 'pluralize'
import moment from 'moment'

export default {
    name: "Event",
    props: {
        event: {
            type: Object
        }
    },
    data: function() {
        return {
            events: {
                component_model_created: "created",
                component_model_edited: "edited",
                component_model_deleted: "deleted",
                component_models_deleted: "deleted",
                component_model_disabled: "disabled",
                component_models_disabled: "disabled",
                component_model_enabled: "enabled",
                component_models_enabled: "enabled",
                component_settings_updated: "updated settings of",
                component_created: "created component",
                component_deleted: "deleted component"
            }
        }
    },
    computed: {
        action() {
            return this.events[this.event.action]
        },

        userName() {
            let user = this.$store.getters.getUser
            return user.uuid == this.event.user.uuid ? "You" : (this.event.user.name == '') ? 'System' : this.event.user.name
        }
    },
    methods: {
        singular(val) {
            return Pluralize.singular(val).replace("_", " ")
        },

        pluralize(val) {
            return Pluralize(val).replace("_", " ")
        }
    },
    mounted() {
    }
}
</script>